import { render } from "./Shop.vue?vue&type=template&id=62f6ee9a"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Shop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62f6ee9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62f6ee9a', __exports__)) {
    api.reload('62f6ee9a', __exports__)
  }
  
  module.hot.accept("./Shop.vue?vue&type=template&id=62f6ee9a", () => {
    api.rerender('62f6ee9a', render)
  })

}


export default __exports__